import classNames from 'classnames'
import * as React from 'react'

import styles from './DisconnectionComment.css'

const UPGRADE_MESSAGE = 'Agent has unregistered (will upgrade)'

type DisconnectionCommentProps = {
  className?: string | undefined
  children?: string | undefined
}
function DisconnectionComment({className, children}: DisconnectionCommentProps) {
  if (children === UPGRADE_MESSAGE) {
    return <span className={className}>{children}</span>
  }

  return (
    <span className={classNames(className, styles.disconnected)}>{`Disconnected${
      children == null ? '' : `, ${children}`
    }`}</span>
  )
}

export default DisconnectionComment
